import { Component, type ReactNode } from 'react';
import { type, surface } from '../theme.js';
import { cn } from '../../lib/cn.js';

/**
 * 只保右栏那几块不把整页拖下水。
 *
 * ── 为什么加这个 ─────────────────────────────────────────────
 *
 * 会话页右栏里的「跟进」「报价与订单」是内部 admin 的组件。开发这一单的时候
 * 撞到过一次:接口返回的形状跟组件预期的对不上,那个组件抛异常,
 * **整个会话页白屏** —— 消息、输入框、24 小时窗口提示,全没了。
 *
 * 工厂端只有这一页真在干活。右栏是加分项,消息和回复框是命脉,
 * 不能让加分项拿到把命脉一起弄没的权力。
 *
 * 这不是在修那个组件(这一单不动 `pages/crm/**`),是在划一条边界:
 * 右栏塌了就只塌右栏,写一句人话,主区照常用。
 */
export class PanelBoundary extends Component<
  { children: ReactNode; label: string },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(err: unknown): void {
    // 留一条给排障 —— 静默吞掉的话没人知道这块塌过
    console.error('[portal] 右栏组件出错', this.props.label, err);
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <div className={cn(surface.card, 'p-4')} data-testid="portal-panel-failed">
          <p className={type.body}>「{this.props.label}」打不开。</p>
          <p className={cn(type.caption, 'mt-1')}>请刷新重试，聊天不受影响。</p>
        </div>
      );
    }
    return this.props.children;
  }
}
